import { authenticatedApi } from "../api";
import { MICROSERVICE_CONFIG } from "../../config/configs";

const BASE = `${MICROSERVICE_CONFIG.ACCOUNTING}/admin/reward-rules`;

export const get_all_reward_rules_api = async (params) => {
	const response = await authenticatedApi.get(`${BASE}?${params}`);
	return response.data;
};

export const get_reward_rule_by_id_api = async (id) => {
	const response = await authenticatedApi.get(`${BASE}/${id}`);
	return response.data;
};

export const add_reward_rule_api = async (body) => {
	const response = await authenticatedApi.post(BASE, body);
	return response.data;
};

export const update_reward_rule_api = async ({ id, body }) => {
	const response = await authenticatedApi.put(`${BASE}/${id}`, body);
	return response.data;
};

export const toggle_reward_rule_status_api = async (id) => {
	const response = await authenticatedApi.patch(`${BASE}/${id}/status`);
	return response.data;
};

export const delete_reward_rule_api = async (id) => {
	const response = await authenticatedApi.delete(`${BASE}/${id}`);
	return response.data;
};
